import { Outlet, useLocation } from "react-router-dom";
import FileUpload from "../components/elements/FileUpload";
import { createContext } from "react";
import TestimonialCloud from "../components/TestimonialCloud";
import HashInterceptor from "../components/HashInterceptor";
import SelfHostHeader from "../components/selfhost/SelfHostHeader";
import Footer from "../components/Footer";


export const QuickShareContext = createContext({})

export default function QuickSharePage({ }) {

  const { state } = useLocation()
  let { files, k, remoteSessionId, transferDirection } = state || {}

  /**
   * `true` if the user has been sent a link, either to receive or send a file
   */
  const hasBeenSentLink = !!(k && remoteSessionId && transferDirection)

  return (
    <div>
      
      
<div className="flex min-h-screen flex-col ">
        <SelfHostHeader />

        <div className="flex-grow">
          <main className="grid  place-items-center align-top px-6   lg:px-8 relative">
        
        <div className="backdrop-blur-sm rounded-xl mt-4 sm:mt-8">
          {/* <h1 className="mt-4 text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Quick Share</h1> */}
          <QuickShareContext.Provider value={{
            hasBeenSentLink,
            files, k, remoteSessionId, transferDirection
          }}>
            <Outlet />
          </QuickShareContext.Provider>
        </div>
      </main>
      {/* <div>
        <h2></h2>
      </div> */}
      {/* <TestimonialCloud/> */}
        </div>

        <Footer />
      </div>
      
    </div>
  )
}